import { render, staticRenderFns } from "./about-helper-components-1-main-page.vue?vue&type=template&id=01a816a6&"
import script from "./about-helper-components-1-main-page.vue?vue&type=script&lang=ts&"
export * from "./about-helper-components-1-main-page.vue?vue&type=script&lang=ts&"
import style0 from "./about-helper-components-1-main-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports